export default __webpack_public_path__ + "assets/c6ef52597f62145e3d6b30fa433ad8a9.png";